<template>
  <button type="button" class="my_comment_item" @click="$emit('click', data)">
    <div class="my_comment_item__meta">
      <span>{{ data.replyComment ? '回复了评论' : '评论了帖子' }}</span>
      <span class="my_comment_item__time">{{ data.timeDesc }}</span>
    </div>
    <p v-if="data.content" class="my_comment_item__content">{{ data.content }}</p>
    <div v-if="data.imgList.length" class="my_comment_item__images">
      <img v-for="url in data.imgList.slice(0, 3)" :key="url" :src="url" alt="" />
    </div>
    <div class="my_comment_item__post">
      <span class="text_ellipsis">{{ data.postTitle }}</span>
      <span class="my_comment_item__arrow">›</span>
    </div>
  </button>
</template>

<script>
export default {
  name: 'ForumMyCommentItem',
  props: { data: { type: Object, required: true } },
};
</script>

<style scoped>
.my_comment_item { display: block; width: 100%; padding: 14px 16px; border: 0; border-bottom: 1px solid #f0f0f0; color: #333; background: #fff; text-align: left; }
.my_comment_item:active { background: #fafafa; }
.my_comment_item__meta { display: flex; align-items: center; color: #999; font-size: 12px; }
.my_comment_item__time { margin-left: auto; }
.my_comment_item__content { margin: 8px 0 0; color: #333; font-size: 14px; line-height: 20px; overflow-wrap: break-word; }
.my_comment_item__images { display: flex; margin-top: 8px; }
.my_comment_item__images img { width: 56px; height: 56px; margin-right: 8px; border-radius: 4px; object-fit: cover; }
.my_comment_item__post { display: flex; align-items: center; min-width: 0; margin-top: 10px; padding: 9px 10px; color: #666; background: #f6f6f6; font-size: 12px; }
.my_comment_item__post > span:first-child { flex: 1; min-width: 0; }
.my_comment_item__arrow { margin-left: 8px; color: #aaa; font-size: 18px; line-height: 1; flex-shrink: 0; }
</style>
